import React from 'react'
import Artists from '../../content/Artists'

const HSlider = (props) => {
  return <Artists {...props} title="H-Slider" />
}

export default HSlider
